// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_0Sp","cls2":"ClaimEvaluationRow-cls2_0G- ClaimEvaluationRow-cls1_0Sp"};